import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import Spinner from 'react-bootstrap/Spinner'

const utils = require("../auxiliar/aux_functions");
const { capitalize } = utils;

class Filters extends Component {

    state = {
        touched: false,
        scientificName: "",
        commonName: "",
        selectedHabitats: [],
        selectedTaxonomy: "",
        selectedEicat: "",
        selectedInvasaquaLists: []
    };

    checkDisabledBtn = () => {

        if (
            this.props.filteringResults ||
            this.props.loading ||
            (
            this.state.scientificName === "" &&
            this.state.commonName === "" &&
            this.state.selectedTaxonomy === "" &&
            this.state.selectedEicat === "" &&
            this.state.selectedHabitats.length === 0 &&
            this.state.selectedInvasaquaLists.length === 0 &&
            !this.state.touched
            )
        ) {
            return true;
        }
        return false;
    };

    changeSelectedTaxonomy = e => {
        this.setState({
            selectedTaxonomy: e.target.value
        });
    };

    changeSelectedEicat = e => {
        this.setState({
            selectedEicat: e.target.value
        });
    };

    onCheckInvasaquaList = e => {

        if (e.target.checked) {
            let newInvasaquaList = this.state.selectedInvasaquaLists;
            newInvasaquaList.push(e.target.value);
            this.setState({
                selectedInvasaquaLists: newInvasaquaList
            });
        } else {
            let newInvasaquaList = this.state.selectedInvasaquaLists.filter(
                h => h !== e.target.value
            );
            this.setState({
                selectedInvasaquaLists: newInvasaquaList
            });
        }
    };

    onCheckHabitat = e => {

        if (e.target.checked) {
            let newHabs = this.state.selectedHabitats;
            newHabs.push(e.target.id);
            this.setState({
                selectedHabitats: newHabs
            });
        } else {
            let newHabs = this.state.selectedHabitats.filter(
                h => h !== e.target.id
            );
            this.setState({
                selectedHabitats: newHabs
            });
        }
    };

    onChangeScientificName = e => {
        this.setState({
            scientificName: e.target.value
        });
    };

    onChangeCommonName = e => {
        this.setState({
            commonName: e.target.value
        });
    };

    onClickfilterBtn = () => {
        this.setState({
            touched: true
        })
        this.props.onFilter(this.state);
    };

    handleKeyDown = (e) => {
        if(e.keyCode === 13) {
            e.preventDefault()
            e.stopPropagation()
            this.setState({
                touched: true
            })
            this.props.onFilter(this.state);
        }
    }

    render() {

        const { t } = this.props

        return (
            <div className="col-md-4" id="filter">
                    <h1 className="linea linea-blanca">
                        {t("filtro-buscador")}
                    </h1>
                    <div className="col-xl-12 no-scroll" style={{margin: 0, padding: 0, maxHeight: 592, overflowY: 'scroll'}}>
                    <form onKeyDown={this.handleKeyDown}>
                        <div className="form-group" style={{marginBottom: 14}}>
                            <label
                                className="col-form-label"
                                htmlFor="nombreCientifico"
                            >
                                {t("filtro-nombreCien")}
                            </label>
                            <input
                                disabled={this.props.loading || this.props.filteringResults}
                                value={this.state.scientificName}
                                onChange={this.onChangeScientificName}
                                type="text"
                                className="form-control col-xl-10 offset-xl-1"
                                id="scientificName"
                                placeholder={t("filtro-placeholder-1")}
                            />
                        </div>
                        <div className="form-group" style={{marginBottom: 14}}>
                            <label
                                className="col-form-label"
                                htmlFor="nombreComun"
                            >
                                {t("filtro-nombreCom")}
                            </label>
                            <input
                                disabled={this.props.loading || this.props.filteringResults}
                                value={this.state.commonName}
                                onChange={this.onChangeCommonName}
                                type="text"
                                className="form-control col-xl-10 offset-xl-1"
                                id="nombreComun"
                                placeholder={t("filtro-placeholder-1")}
                            />
                        </div>
                        <div className="form-group" style={{marginBottom: 14}}>
                            <label className="col-form-label">{t("filtro-entorno")}</label>
                            <div className="col-xl-10 offset-xl-1" style={{paddingLeft: 0}}>
                                {this.props.loading
                                    ? <MiniSpinner/>
                                    : this.props.habitats.map((hab, i) => {
                                          return (
                                              <div
                                                  key={hab.habitat_id}
                                                  className="form-check form-check-inline "
                                              >
                                                  <input
                                                      checked={
                                                          this.state.selectedHabitats.indexOf(
                                                              hab.habitat_id
                                                          ) !== -1
                                                      }
                                                      onChange={
                                                          this.onCheckHabitat
                                                      }
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={hab.habitat_id}
                                                      name={hab.habitat_id}
                                                      value={hab.habitat_id}
                                                      disabled={this.props.filteringResults}
                                                  />
                                                  <label
                                                      className="form-check-label"
                                                      htmlFor={hab.habitat_id}
                                                  >
                                                      {capitalize(hab.habitat)}
                                                  </label>
                                              </div>
                                          );
                                      })}
                            </div>
                        </div>
                        <div className="form-group" style={{marginBottom: 14}}>
                            <label
                                htmlFor="taxonomia"
                                className="col-form-label"
                            >
                                {t("filtro-taxonomia")}
                            </label>
                            <div className="col-xl-10 offset-xl-1 px-0">
                                <select
                                    className="form-control"
                                    id="taxonomia"
                                    value={this.state.selectedTaxonomy}
                                    onChange={this.changeSelectedTaxonomy}
                                    disabled={this.props.loading || this.props.filteringResults}
                                >
                                    <option value="">
                                        {t("filtro-placeholder-2")}
                                    </option>
                                    {this.props.taxonomies.map((tax, i) => {
                                        return (
                                            <option
                                                key={tax.taxonomic_group}
                                                value={tax.taxonomic_group}
                                            >
                                                {tax.taxonomic_group}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="form-group" style={{marginBottom: 14}}>
                            <label
                                htmlFor="eicat"
                                className="col-form-label"
                            >
                                {t("filtro-eicat")}
                            </label>
                            <div className="col-xl-10 offset-xl-1 px-0">
                                <select
                                    className="form-control"
                                    id="eicat"
                                    value={this.state.selectedEicat}
                                    onChange={this.changeSelectedEicat}
                                    disabled={this.props.loading || this.props.filteringResults}
                                >
                                    <option value="">
                                        {t("filtro-placeholder-2")}
                                    </option>
                                    {this.props.eicatCategories.map((cat, i) => {
                                        return (
                                            <option
                                                key={cat.eicat_id}
                                                value={cat.eicat_id}
                                            >
                                                {cat.eicat}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="form-group" style={{marginBottom: 14}}>
                            <label className="col-form-label">{t("filtro-invasaqualist")}</label>
                            <div className="col-xl-10 offset-xl-1" style={{paddingLeft: 0}}>
                                {this.props.loading
                                    ? <MiniSpinner/>
                                    : this.props.invasaquaLists.map((list, i) => {
                                          return (
                                              <div
                                                  key={list.invasaqua_id+"_"+list.invasaqua}
                                                  className="form-check form-check-inline "
                                              >
                                                  <input
                                                      checked={
                                                          this.state.selectedInvasaquaLists.indexOf(
                                                              list.invasaqua_id
                                                          ) !== -1
                                                      }
                                                      onChange={
                                                          this.onCheckInvasaquaList
                                                      }
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={list.invasaqua_id+"_"+list.invasaqua}
                                                      name={list.invasaqua_id}
                                                      value={list.invasaqua_id}
                                                      disabled={this.props.filteringResults}
                                                  />
                                                  <label
                                                      className="form-check-label"
                                                      htmlFor={list.invasaqua_id+"_"+list.invasaqua}
                                                  >
                                                      {capitalize(list.invasaqua)}
                                                  </label>
                                              </div>
                                          );
                                      })}
                            </div>
                        </div>

                        <button
                            type="button"
                            className={this.checkDisabledBtn() ? "btn btn-primary col-xl-11 disabled-filter-btn": "btn btn-primary col-xl-11"}
                            disabled={this.checkDisabledBtn()}
                            onClick={this.onClickfilterBtn}
                        >
                            <strong>{t("filtro-btnBuscar-1")}</strong> {t("filtro-btnBuscar-2")}
                        </button>
                    </form>
                    </div>
            </div>
        );
    }
}

// export default Species;
export default withTranslation()(Filters);

const MiniSpinner = props => (
        <div style={{display: 'flex'}}>
            <Spinner animation="grow" size="sm" variant="secondary" style={{marginRight: 5}}/>
            <Spinner animation="grow" size="sm" variant="secondary" style={{marginRight: 5}}/>
            <Spinner animation="grow" size="sm" variant="secondary" />
        </div>
)
